import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  isAuthenticated(): boolean {
    if (this.isAdmin() && this.isTokenExpires()) {
      return true;
    } else {
      return false;
    }
  }

  isTokenExpires(): boolean {
    const expirationDate = this.getIdentity().exp * 1000;
    const dateNow = Date.now();

    return expirationDate > dateNow;
  }

  isAdmin(): boolean {
    return this.getIdentity().rol == 1 || this.getIdentity().rol == 2
      ? true
      : false;
  }

  getIdentity() {
    const local = localStorage.getItem('identity');

    let identity = JSON.parse(local ? local : '');

    if (identity && identity != 'undefined') {
      return identity;
    } else {
      return null;
    }
  }

  getToken() {
    let token = localStorage.getItem('token');

    if (token && token != 'undefined') {
      return token;
    } else {
      return null;
    }
  }

  getRole(): number {
    const user = this.getIdentity();
    return user.rol;
  }

  isUserAllowed(allowedRoles: number[]) {
    if (!allowedRoles || allowedRoles.length === 0) {
      return true;
    }

    const role = this.getRole();

    return allowedRoles.includes(role);
  }

  /**
   * Roles asignados al usuario (`identity.roles`), provenientes de `user_role`
   * en base de datos. A diferencia de `getRole()`/`identity.rol` (rol principal
   * legacy, prácticamente el primer rol registrado), este arreglo puede
   * contener múltiples roles.
   *
   * No hace fallback a `identity.rol`: si `identity.roles` no existe o no es
   * un arreglo válido, se considera que el usuario no tiene roles asignados.
   */
  getAssignedRoles(): number[] {
    const identity = this.getIdentity();
    const roles = identity?.roles;

    if (!Array.isArray(roles)) {
      return [];
    }

    return roles
      .map((roleId: unknown) => Number(roleId))
      .filter((roleId: number) => !Number.isNaN(roleId));
  }

  /**
   * Autoriza usando `identity.roles` (múltiples roles asignados) en lugar del
   * rol principal legacy. Úsese para funcionalidades nuevas cuyo backend
   * autorice contra `user_role` (por ejemplo, generación manual de recibos
   * mensuales, exclusiva de Super Admin vía `user_role.role_id`).
   *
   * Precedente de migración: cuando se refactorice la autorización legacy
   * basada en `identity.rol`, este debe ser el mecanismo a generalizar.
   */
  hasAnyAssignedRole(requiredRoleIds: number[]): boolean {
    if (!requiredRoleIds || requiredRoleIds.length === 0) {
      return true;
    }

    const assignedRoles = this.getAssignedRoles();

    return assignedRoles.some(roleId => requiredRoleIds.includes(roleId));
  }

  getComponentPermissions(permissions: any) {
		let filtered: any = {};
		for (const prop in permissions) {
			if (this.isUserAllowed(permissions[prop])) {
				filtered[prop] = true;
			} else {
				filtered[prop] = false;
			}
		}

		return filtered;
	}
}
